module.exports = __webpack_public_path__ + "static/media/telefonica-movistar.1663c5e1.png";